import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IBoosterData} from "../reducers/booster-data.reducer";
import {BoosterPageMapper} from "../../websites/website/booster/mappers/booster-page-mapper";
import {WebpMapper} from "../../websites/website/booster/mappers/webp-mapper";
import {CacheStatusMapper} from "../../websites/website/booster/mappers/cache-status-mapper";
import {OptimizeStatusMapper} from "../../websites/website/booster/mappers/optimize-status-mapper";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getBoosterDataState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.boosterData);

export const getWebsiteBoosterDataLoaded = (websiteId: number) => createSelector(getBoosterDataState,
  (state: IBoosterData): any => state.entities[websiteId] && state.entities[websiteId].loaded ? state.entities[websiteId].loaded : null
);

export const getWebsiteBoosterDataLoading = (websiteId: number) => createSelector(getBoosterDataState,
  (state: IBoosterData): any => state.entities[websiteId] && state.entities[websiteId].loading
    ? state.entities[websiteId].loading : null
);

export const getWebsiteBoosterPages = (websiteId: number) => createSelector(getBoosterDataState,
  (state: IBoosterData): any => state.entities[websiteId] && state.entities[websiteId].pages
    ? state.entities[websiteId].pages.map(page => BoosterPageMapper.map(page)) : null
);

export const getWebsiteBoosterPagesCount = (websiteId: number) => createSelector(getBoosterDataState,
  (state: IBoosterData): any => state.entities[websiteId] && state.entities[websiteId].pagesCount
    ? state.entities[websiteId].pagesCount : null
);

export const getWebsiteBoosterPagesWithoutFrontPage = (websiteId: number) => createSelector(getBoosterDataState,
  (state: IBoosterData): any => state.entities[websiteId] && state.entities[websiteId].pages
    ? state.entities[websiteId].pages.map(page => BoosterPageMapper.map(page)).filter(page => page.id !== 'front_page') : null
);

export const getWebsiteBoosterCustomPages = (websiteId: number) => createSelector(getBoosterDataState,
  (state: IBoosterData): any => state.entities[websiteId] && state.entities[websiteId].customPages
    ? state.entities[websiteId].customPages.map(page => BoosterPageMapper.map(page)) : null
);

export const getWebsiteBoosterModeLevel = (websiteId: number) => createSelector(getBoosterDataState,
  (state: IBoosterData): any => state.entities[websiteId] && state.entities[websiteId].modeLevel ? state.entities[websiteId].modeLevel : null
);

export const getWebsiteBoosterIncompatibleActivePlugins = (websiteId: number) => createSelector(getBoosterDataState,
  (state: IBoosterData): any => state.entities[websiteId] && state.entities[websiteId].incompatibleActivePlugins ? state.entities[websiteId].incompatibleActivePlugins : null
);

export const getBoosterPluginInfo = (websiteId: number) => createSelector(getBoosterDataState,
  (state: IBoosterData): any => state.entities[websiteId] && state.entities[websiteId].pluginInfo ? state.entities[websiteId].pluginInfo : null
);

export const getWebsiteWebpStatus = (websiteId: number) => createSelector(getBoosterDataState,
  (state: IBoosterData): any => state.entities[websiteId] && state.entities[websiteId].webpStatus ? WebpMapper.map(state.entities[websiteId].webpStatus) : null
);

export const getWebsiteCacheStatus = (websiteId: number) => createSelector(getBoosterDataState,
  (state: IBoosterData): any => state.entities[websiteId] && state.entities[websiteId].pageCacheStatus ? CacheStatusMapper.map(state.entities[websiteId].pageCacheStatus) : null
);

export const getWebsiteBoosterTestMode = (websiteId: number) => createSelector(getBoosterDataState,
  (state: IBoosterData): any => state.entities[websiteId] && state.entities[websiteId].testMode ? state.entities[websiteId].testMode : false
);

export const getWebsiteBoosterOptimizeStatus = (payload: {websiteId: number, pageUrl: string}) => createSelector(getBoosterDataState,
  (state: IBoosterData): any => state.entities[payload.websiteId] && state.entities[payload.websiteId].optimizeStatus ? OptimizeStatusMapper.map(state.entities[payload.websiteId].optimizeStatus) : null
);



